/* eslint @typescript-eslint/consistent-type-assertions: "off" */
import type { Action as ReduxAction } from 'redux'
import type { PayloadAction } from '@reduxjs/toolkit'
export type { PayloadAction }

export type ARedux<Type, Meta = void> = ReduxAction<Type> & { meta?: Meta }

export const makeActionTypeMaker =
  <PrefixType extends string>(prefix: PrefixType) =>
  <Type extends string>(actionName: Type) =>
    (prefix + '_' + actionName) as Type

export const createActionType = <
  PrefixType extends string,
  Type extends string
>(
  prefix: PrefixType,
  actionName: Type
) => makeActionTypeMaker(prefix)(actionName)
